import type { ReactNode, FC } from 'react';
import classes from './PageFrame.layout.module.css';

interface Props {
  menu?: React.ReactElement;
  /*
    CSS overflow setting for page content. (Defaults to auto in component)
    Set to visible to allow content to be visible on top of menu in Safari.
  */
  contentOverflow?: string;
  inspectMode?: boolean;
  children?: ReactNode;
}

export const PageFrame: FC<Props> = ({
  contentOverflow = 'auto',
  ...props
}) => {
  return (
    <div
      data-testid="page-layout"
      data-inspect-mode={props.inspectMode || undefined}
      className={`${classes.container} ${
        props.inspectMode ? classes.containerInspectMode : ''
      }`}
    >
      {props.menu && (
        <div data-testid="page-layout-menu" className={classes.menu}>
          {props.menu}
        </div>
      )}
      <div
        data-testid="page-layout-content"
        className={classes.content}
        style={{ overflow: contentOverflow }}
      >
        {props.children}
      </div>
    </div>
  );
};
